import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { FormControl, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  fullWidth: {
    width: '700px'
  },
  root: {
    width: '300px'
  }
});

const TableHeader = ({ handleLookup }) => {
  const [customerId, setCustomerId] = useState("");
  const classes = useStyles();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLookup(customerId);
    }
  };

  return (
    <>
      <div className="table-filter-body">
        <div className="form-container">
          <div className="flex field-button-container">
            <FormControl variant="standard" className="form-control w-50">
              <TextField
                className={classes.root}
                id="standard-basic"
                label="Search for variants by customer id"
                name="search"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </FormControl>
            <div className="flex flex-wrap justify-between w-50">
              <Button variant="outlined" onClick={(e) => handleLookup(customerId)}>
                Search
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

TableHeader.propTypes = {
  handleLookup: PropTypes.func
};

export default TableHeader;
